module.exports = __webpack_public_path__ + "static/Truck5-6371ccab87693afcfc18bb290556e08a.png";